import { Link } from 'react-router-dom';

export default function RequestHero() {
  return (
    <section className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white py-20 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative z-10">
        {/* Breadcrumb */}
        <nav className="mb-8 text-sm">
          <Link to="/" className="text-gray-400 hover:text-white transition-colors whitespace-nowrap">Home</Link>
          <span className="mx-2 text-gray-600">/</span>
          <Link to="/broker-services" className="text-gray-400 hover:text-white transition-colors whitespace-nowrap">Broker Services</Link>
          <span className="mx-2 text-gray-600">/</span>
          <span className="text-white whitespace-nowrap">Request a Vehicle</span>
        </nav>

        {/* Main Heading */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-500/30 rounded-full px-4 py-2 mb-6">
            <i className="ri-vip-crown-line text-amber-400 text-lg"></i>
            <span className="text-amber-400 font-semibold text-sm whitespace-nowrap">Premium Vehicle Sourcing</span>
          </div>
          
          <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
            Tell Us What You Want.<br />
            <span className="text-amber-400">We'll Find It For You.</span>
          </h1>
          
          <p className="text-xl text-gray-300 max-w-2xl mx-auto mb-8">
            Skip the dealership games. Our broker service hunts down the perfect vehicle, inspects it thoroughly, negotiates the best price, and delivers it to your door.
          </p>

          {/* Trust Signals */}
          <div className="flex flex-wrap justify-center gap-6 md:gap-8">
            <div className="text-center">
              <div className="text-3xl font-bold text-amber-400 mb-1">$3,200</div>
              <div className="text-sm text-gray-400 whitespace-nowrap">Avg. Savings</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-amber-400 mb-1">$500</div>
              <div className="text-sm text-gray-400 whitespace-nowrap">Flat Fee</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-amber-400 mb-1">100%</div>
              <div className="text-sm text-gray-400 whitespace-nowrap">Transparent</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}